import { MemberType } from 'api/models';

export enum PermissionSetObjectType {
  Account = 'ACCOUNT',
  Project = 'PROJECT',
}

export enum ProjectPermissionSetType {
  Owner = 2,
  VendorCollaborator = 3,
  CustomerCollaborator = 4,
  CustomerChampion = 5,
  Observer = 6,
}

export interface PermissionSetBase {
  permissionSetName: string;
  permissionSetSpecificTo: MemberType;
}

export interface ProjectPermissionSet extends PermissionSetBase {
  permissionSetType: ProjectPermissionSetType;
  permissionSetObjectType: PermissionSetObjectType.Project;
}

export enum AccountPermissionSetType {
  Admin = 1,
  SuperUser = 7,
  VendorCollaborator = 8,
  CustomerCollaborator = 10,
  PartnerAdmin = 11,
  PartnerMember = 12,
  PartnerCollaborator = 13,
}

export interface AccountPermissionSet extends PermissionSetBase {
  permissionSetType: AccountPermissionSetType;
  permissionSetObjectType: PermissionSetObjectType.Account;
}

export type PermissionSet = AccountPermissionSet | ProjectPermissionSet;
